<!--首页-->
<template>
  <div class="contentBox">
    <template v-if="siteType == 1">
      <NewIndex />
    </template>
    <template v-else>
      <div class="contentMain">
        <!-- 顶部招聘职位相关 -->
        <div class="jobfairTop">
          <div class="jobfairImg">
            <img id="myimg" :src="head_img_url" alt="" width="584px" height="210px">
          </div>
          <div class="jobInfoContent" :style="{background:color}" v-if="data0.show && isColorFlag">
            <div style="display: flex; height: 52px; margin-bottom: 24px;">
              <div class="jobfairInfo">
                <div class="imageStyle">
                  <img src="../assets/index-company.png" alt="" width="32px" height="32px">
                </div>
                <div class="textInfo" v-if="datalist[0]">
                  <div class="number">{{datalist[0].value}}</div>
                  <div class="textdesc">{{datalist[0].label}}</div>
                </div>
              </div>
              <div class="jobfairInfo">
                <div class="imageStyle">
                  <img src="../assets/index-position.png" alt="" width="32px" height="32px">
                </div>
                <div class="textInfo" v-if="datalist[1]">
                  <div class="number">{{datalist[1].value}}</div>
                  <div class="textdesc">{{datalist[1].label}}</div>
                </div>
              </div>
            </div>
            <div style="display: flex; height: 52px;">
              <div class="jobfairInfo">
                <div class="imageStyle">
                  <img src="../assets/index-demoned.png" alt="" width="32px" height="32px">
                </div>
                <div class="textInfo" v-if="datalist[2]">
                  <div class="number">{{datalist[2].value}}</div>
                  <div class="textdesc">{{datalist[2].label}}</div>
                </div>
              </div>
              <div class="jobfairInfo">
                <div class="imageStyle">
                  <img src="../assets/index-sort.png" alt="" width="32px" height="32px">
                </div>
                <div class="textInfo" v-if="datalist[3]">
                  <div class="number">{{datalist[3].value}}</div>
                  <div class="textdesc">{{datalist[3].label}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="jobInfoContentCopy" v-if="data0.show && !isColorFlag">
            <div style="display: flex; height: 52px; margin-bottom: 24px;">
              <div class="jobfairInfo">
                <div class="imageStyle">
                  <img src="@/assets/homeImg/qiye.png" alt="" width="32px" height="32px">
                </div>
                <div class="textInfo" v-if="datalist[0]">
                  <div class="number">{{datalist[0].value}}</div>
                  <div class="textdesc">{{datalist[0].label}}</div>
                </div>
              </div>
              <div class="jobfairInfo">
                <div class="imageStyle">
                  <img src="@/assets/homeImg/zhiwei.png" alt="" width="32px" height="32px">
                </div>
                <div class="textInfo" v-if="datalist[1]">
                  <div class="number">{{datalist[1].value}}</div>
                  <div class="textdesc">{{datalist[1].label}}</div>
                </div>
              </div>
            </div>
            <div style="display: flex; height: 52px;">
              <div class="jobfairInfo">
                <div class="imageStyle">
                  <img src="@/assets/homeImg/yongren.png" alt="" width="32px" height="32px">
                </div>
                <div class="textInfo" v-if="datalist[2]">
                  <div class="number">{{datalist[2].value}}</div>
                  <div class="textdesc">{{datalist[2].label}}</div>
                </div>
              </div>
              <div class="jobfairInfo">
                <div class="imageStyle">
                  <img src="@/assets/homeImg/zhonglie.png" alt="" width="32px" height="32px">
                </div>
                <div class="textInfo" v-if="datalist[3]">
                  <div class="number">{{datalist[3].value}}</div>
                  <div class="textdesc">{{datalist[3].label}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-for="item in sortList" :key="item.label">
          <!-- 学院专区 -->
          <div v-if="item.label == '院系专区'">

            <div class="college-content" v-if="school0.show && schoolZone.length > 0">
              <div class="college-title">
                {{school0.title}}
              </div>
              <div class="college-item">
                <div :style="{visibility: schIndex ?'': 'hidden'}" class="flip-left changeStyle" @click="delschIndex">
                  <!-- <img src="../assets/left_normal.png" alt="" width="24px" height="48px" > -->
                  <img @mouseenter="mouseenterCollegeLeft" @mouseout="mouseoutCollegeLeft"  @mousedown="mousedownCollegeLeft" @mouseup="mouseupCollegeLeft" :src="showCollegeleftNomal ? require('../assets/left_normal.png') : showCollegeleftHover ? require('../assets/left_hover.png') : require('../assets/left_press.png')" alt="" width="24px" height="48px">

                </div>
                <div v-if="index == schIndex" class="college-img changeStyle" v-for="(item,index) in schoolZone" :key="index">
                  <div class="imgBox" v-for="(itemS,i) in item" :key="i"  @click="handleCollege(itemS)">
                    <img :src="itemS.thumbnail_url" alt="" width="85px" height="85px">
                  </div>
                </div>
                <div :style="{visibility: schIndex < schoolZone.length-1 && schIndex >= 0?'': 'hidden'}" class="flip-right changeStyle" @click="addschIndex">
                  <!-- <img src="../assets/right_normal.png" alt="" width="24px" height="48px"> -->
                  <img @mouseenter="mouseenterCollegeRight" @mouseout="mouseoutCollegeRight"  @mousedown="mousedownCollegeRight" @mouseup="mouseupCollegeRight" :src="showCollegerightNomal ? require('../assets/right_normal.png') : showCollegerightHover ? require('../assets/right_hover.png') : require('../assets/right_press.png')" alt="" width="24px" height="48px">

                </div>
              </div>
            </div>
          </div>

          <div v-if="item.label == '企业配置'">
            <!-- 企业配置 -->
            <div class="enterprise-confing" v-if="company0.show && companyConfingArr[comIndex].length > 0">
              <div class="enterprise-top">
                <div class="enterprise-title">{{company0.title}}</div>
                <div @click="handleClickcompanyAll" :class=" active == 0 ? 'view-morePress changeStyle':  'view-more changeStyle'" @mousedown="enterAll" @mouseup="mouseupAll"><span>查看全部</span><i style="margin-left: 4px" class="iconfont icon_more"></i></div>
              </div>
              <div class="host-content">
                <div class="flip-left changeStyle" :style="{visibility: comIndex ?'': 'hidden'}" @click="comDel">
                  <!-- <img src="../assets/left_normal.png" alt="" width="24px" height="48px" > -->
                  <img @mouseenter="mouseenterCompanyLeft" @mouseout="mouseoutCompanyLeft"  @mousedown="mousedownCompanyLeft" @mouseup="mouseupCompanyLeft" :src="showCompanyleftNomal ? require('../assets/left_normal.png') : showCompanyleftHover ? require('../assets/left_hover.png') : require('../assets/left_press.png')" alt="" width="24px" height="48px">
                </div>
                <div class="enterprise-content changeStyle">
                  <div v-for="(item,index) in companyConfingArr[comIndex] " :key="index" class="content-model" @click="handleCompanyconfing(item.id)">
                    <div class="content-box">
                      <div class="content-left">
                        <img :src="item.logo_url" alt="" width="64px" height="64px">
                      </div>
                      <div class="content-right">
                        <div class="companyName">{{item.company_name}}</div>
                        <div class="companyLabel">{{ item.industry_label}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flip-right changeStyle" :style="{visibility: comIndex < companyConfingArr.length-1 && comIndex >= 0?'': 'hidden'}" @click="comAdd">
                  <img @mouseenter="mouseenterCompanyRight" @mouseout="mouseoutCompanyRight"  @mousedown="mousedownCompanyRight" @mouseup="mouseupCompanyRight" :src="showCompanyrightNomal ? require('../assets/right_normal.png') : showCompanyrightHover ? require('../assets/right_hover.png') : require('../assets/right_press.png')" alt="" width="24px" height="48px">
                </div>
              </div>
            </div>
          </div>

          <!-- 运营一区 -->
          <div v-if="item.label == '运营一区'">

            <div class="host-position" v-if="open1.show && zoneOne.length > 0">
              <div class="host-title">
                {{open1.title}}
              </div>
              <div class="host-content changeStyle">
                <div class="flip-left" :style="{visibility: bigfourIndex ?'': 'hidden'}" @click="prevIndex">
                  <!-- <img src="../assets/left_normal.png" alt="" width="24px" height="48px" > -->
                  <img @mouseenter="mouseenterOneLeft" @mouseout="mouseoutOneLeft"  @mousedown="mousedownOneLeft" @mouseup="mouseupOneLeft" :src="showleftNomal ? require('../assets/left_normal.png') : showrightHover ? require('../assets/left_hover.png') : require('../assets/left_press.png')" alt="" width="24px" height="48px">

                </div>
                <div class="host-img" v-if="index == bigfourIndex" v-for="(itemList,index) in zoneOne" :key="index">
                  <div class="host-Box" v-for="(itemList1,i) in itemList" :key="i" @click="zoneOneClick(itemList1.id,itemList1.config_type,itemList1.config_content,itemList1)">
                    <div class="host-item-img">
                      <img :src="itemList1.icon" alt="" width="56px" height="56px">
                    </div>
                    <div class="host-name" :style="{'color': isChinaTaiWan ? '#17233D' : '#333333', 'fontWeight': isChinaTaiWan ? 'bold' : 'normal'}">{{itemList1.title}}</div>
                  </div>

                </div>
                <div class="flip-right" :style="{visibility: bigfourIndex < zoneOne.length-1 && bigfourIndex >= 0?'': 'hidden'}" @click="nextIndex">
                  <!-- <img src="../assets/right_normal.png" alt="" width="24px" height="48px"> -->
                  <img @mouseenter="mouseenter" @mouseout="mouseout"  @mousedown="mousedown" @mouseup="mouseup" :src="showrightNomal ? require('../assets/right_normal.png') : showrightHover ? require('../assets/right_hover.png') : require('../assets/right_press.png')" alt="" width="24px" height="48px">

                </div>
              </div>
            </div>
          </div>
          <div v-if="item.label == '招聘会'">
            <!-- 横幅招聘会 -->
            <div class="swiper changeStyle" v-if="jobfair0.show && swiperList.length > 0">

              <!-- <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item,index) in swiperList" :key="index">
                    <div style="width: 592px; height:174px;" class="swiper-box">
                     <img width="100%" height="100%" :src="item.home_thumbnail_url" alt="" style="border-radius: 8px;object-fit:cover;">
                    </div>
                  </div>
              </div>
              <div class="swiper-pagination"></div> -->
              <!-- <el-carousel indicator-position="outside"  :arrow=" swiperList.length > 1 ? 'always' :'never'" height="174px"> -->
              <el-carousel indicator-position="outside" arrow="never" height="114px">
                <el-carousel-item v-for="(item,index) in swiperList" :key="index">
                  <!-- <el-carousel-item > -->

                  <div class="swiper-itemStyle">
                    <div style="width: 389px; height:114px;" class="swiper-box" v-for="(items,index) in item" :key="index" @click="handleJobfair(items)">
                      <img width="100%" height="100%" :src="items.home_thumbnail_url" alt="" style="border-radius: 8px;object-fit:cover;">
                    </div>
                  </div>
                  <!-- <div class="swiper-box">
                    <img  width="100%" height="100%"  src="../assets/img-collage.png" alt="" style="border-radius: 8px;object-fit:cover;">
                  </div> -->
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div v-if="item.label == '职位配置'">
            <!-- 职位配置 -->
            <div class="position-confing" v-if="position0.show && positionConfingArr.length > 0">
              <div class="position-content">
                <div class="position-title">{{position0.title}}</div>
                <div v-if="length == 0">
                  <div style="display: flex;flex-wrap: wrap;" >
                    <div class="position-item changeStyle" v-for="(posItems,index) in positionConfingArr" :key="index" @click="handlPosition(posItems.value, posItems.label, posItems.period)">
                      {{posItems.aliasName}}
                      <div v-if="posItems.isHot" class="host">
                        <img src="../assets/label-hot.png" alt="" width="36px" height="20px">
                      </div>
                    </div>

                  </div>
                </div>
                <div v-if="length == 1">
                  <div v-if="!allposition" style="display: flex;flex-wrap: wrap; justify-content: space-around;" >
                    <div class="position-item changeStyle" v-for="(posItems,index) in positionConfingArr" :key="index"  @click="handlPosition(posItems.value, posItems.label, posItems.period)">
                      {{posItems.aliasName}}
                      <div v-if="posItems.isHot" class="host">
                        <img src="../assets/label-hot.png" alt="" width="36px" height="20px">
                      </div>
                    </div>
                  </div>
                  <div v-if="allposition" style="display: flex;flex-wrap: wrap;" >
                    <div class="position-item changeStyle" v-for="(posItems,index) in newposConfingArr" :key="index"  @click="handlPosition(posItems.value, posItems.label, posItems.period)">
                      {{posItems.aliasName}}
                      <div v-if="posItems.isHot" class="host">
                        <img src="../assets/label-hot.png" alt="" width="36px" height="20px">
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="newposConfingArr.length > 20 && !allposition" @click="allPosition" @mousedown="mousedownPositionAll" @mouseup="mouseupPositionAll" :class="active==0 ? 'seeAllPress changeStyle' :'seeAll changeStyle'">查看全部</div>
                <div v-if="allposition" @click="closePosition"  @mousedown="mousedownPositionAll" @mouseup="mouseupPositionAll" :class="active==0 ? 'seeAllPress changeStyle' :'seeAll changeStyle'" >收起</div>
              </div>

            </div>
          </div>

          <div v-if="item.label == '运营二区'">
            <!-- 运营二区 -->
            <div class="zone-two" v-if="open2.show && newcompanyArea.length > 0">
              <div class="two-title">
                {{open2.title}}
              </div>
              <div class="two-item changeStyle">
                <div :style="{visibility: arrIndex ?'': 'hidden'}" class="flip-left" @click="delIndex">
                  <!-- <img src="../assets/left_normal.png" alt="" width="24px" height="48px" > -->
                  <img @mouseenter="mouseenterTwoLeft" @mouseout="mouseoutTwoLeft"  @mousedown="mousedownTwoLeft" @mouseup="mouseupTwoLeft" :src="showTwoLeftNomal ? require('../assets/left_normal.png') : showTwoLeftHover ? require('../assets/left_hover.png') : require('../assets/left_press.png')" alt="" width="24px" height="48px">

                </div>
                <div v-if="index == arrIndex" class="two-img" v-for="(item,index) in newcompanyArea" :key="index" >
                  <div class="two-imgBox" v-for="(itemImg,i) in item" :key="i" @click="zoneTwoClick(itemImg.id,itemImg.config_type,itemImg.config_content,itemImg)">
                    <img :src="itemImg.icon" alt="" width="85px" height="85px">
                  </div>
                </div>
                <div :style="{visibility: arrIndex < newcompanyArea.length-1 && arrIndex >= 0?'': 'hidden'}" class="flip-right" @click="addIndex">
                  <!-- <img src="../assets/right_normal.png" alt="" width="24px" height="48px"> -->
                  <img @mouseenter="mouseenterTwoRight" @mouseout="mouseoutTwoRight"  @mousedown="mousedownTwoRight" @mouseup="mouseupTwoRight" :src="showTwoRightNomal ? require('../assets/right_normal.png') : showTwoRightHover ? require('../assets/right_hover.png') : require('../assets/right_press.png')" alt="" width="24px" height="48px">

                </div>
              </div>
            </div>
          </div>
          <div v-if="item.label == '运营三区'">
            <!-- 运营三区 -->
            <div class="zone-three" v-if="open3.show && zoneThree.length > 0">
              <div class="three-title">
                {{open3.title}}
              </div>
              <div class="three-box changeStyle">
                <div v-for="(item,index) in zoneThree" :key="index" class="three-imgbox" @click="handleZonethree(item.id,item.config_type,item.config_content,item)" style="margin-right: 16px;">
                  <img :src="item.icon" alt="" width="196px" height="82px" style="border-radius: 6px;">
                </div>
              </div>
            </div>
          </div>
          <div v-if="item.label == '运营四区'">
            <!-- 运营四区 -->
            <div class="zone-four" v-if="open4.show && zoneFour.length > 0">
              <div class="four-title">
                {{open4.title}}
              </div>
              <div class="four-item changeStyle">
                <div :style="{visibility: fourIndex ?'': 'hidden'}" class="flip-left" @click="delfourIndex">
                  <!-- <img src="../assets/left_normal.png" alt="" width="24px" height="48px" > -->
                  <img @mouseenter="mouseenterFourLeft" @mouseout="mouseoutFourLeft"  @mousedown="mousedownFourLeft" @mouseup="mouseupFourLeft" :src="showFourLeftNomal ? require('../assets/left_normal.png') : showFourLeftHover ? require('../assets/left_hover.png') : require('../assets/left_press.png')" alt="" width="24px" height="48px">

                </div>
                <div v-if="index == fourIndex" class="four-img" v-for="(item,index) in zoneFour" :key="index">
                  <div class="four-imgBox" v-for="(itemImg,i) in item" :key="i" @click="handleZoneFour(itemImg.id,itemImg.config_type,itemImg.config_content,itemImg)">
                    <img :src="itemImg.icon" alt="" width="85px" height="85px">
                  </div>
                </div>
                <div :style="{visibility: fourIndex < zoneFour.length-1 && fourIndex >= 0?'': 'hidden'}" class="flip-right" @click="addfourIndex">
                  <!-- <img src="../assets/right_normal.png" alt="" width="24px" height="48px"> -->
                  <img @mouseenter="mouseenterFourRight" @mouseout="mouseoutFourRight"  @mousedown="mousedownFourRight" @mouseup="mouseupFourRight" :src="showFourRightNomal ? require('../assets/right_normal.png') : showFourRightHover ? require('../assets/right_hover.png') : require('../assets/right_press.png')" alt="" width="24px" height="48px">

                </div>
              </div>
            </div>
          </div>

        </div>
        <!-- 关于 -->
        <div class="about" v-if="about0.show">
          <div class="left-line"></div>
          <div class="aboutCon changeStyle" @click="handleAbout">{{aboutTitle}}</div>
          <div class="right-line"></div>
        </div>
      </div>
      <aboutJobfair v-if="listModal" :jobfairIcon="jobfairIcon" @handleClosed="handleCloseClicks"></aboutJobfair>
      <!--  登录弹框-学生  -->
      <!-- <login-dialog :isJump="isJump" :videoDetailUrl="videoDetailUrl" @closeClick="handleCloseClick('4')" v-if="loginDialogShow"></login-dialog> -->
      <!-- 切换登录状态   -->
      <!-- <switch-login-status :switchType="'2'" v-if="stateDialogShow" @handleClose="handleCloseClick('5')"></switch-login-status> -->
    </template>

  </div>
</template>

<script>
import aboutJobfair from '@/components/dialog/aboutJobfair.vue'
import {gethomeConfig,getSchoolData,getsiteInfo, getsitecollege, getsitemajors} from '@/api/indexPage'
import switchLoginStatus from '@/components/dialog/switchLoginStatus.vue'
import {eventBus} from '@/utils/eventBus'
import { setMeta } from "@/utils/utils";
import Swiper from 'swiper'
import Cookies from 'js-cookie'
import NewIndex from "@/components/newIndex/index.vue";
export default {
  data() {
    return {
      siteType: '',
      imgData:'../assets/image/banner-ysyc.png',
      // color:'rgb(0,113,249)',
      color:'',
      bgcolor:'',
      isGetcolor:false,
      head_img_url:'',
      datalist:[],
      newcompanyArea:[],
      arrIndex: 0,
      // 运营一区
      zoneOne: [],
      bigfourIndex: 0,
      // 是否展示查看全部
      show_all:'',
      // 企业配置
      companyConfingArr:[],
      //企业配置第一屏index
      comIndex: 0,
      positionConfingArr: [],
      newposConfingArr:[],
      length: 0,
      allposition: false,
      swiperList: [],
      zoneThree: [],
      zoneFour: [],
      fourIndex: 0,
      listModal:false,
      jobfairIcon:{},
      schoolZone:[],
      schIndex: 0,
      exhibition:[],
      sortList:[],

      data0:'',
      school0:'' ,
      open1:'' ,
      open2:'' ,
      open3:'' ,
      open4:'' ,
      company0:'' ,
      jobfair0:'',
      position0:'',
      about0:'',
      aboutTitle:'',

      lNormal:'../assets/left_normal.png',
      lHover:'../assets/left_hover.png',
      lPress:'../assets/left_press.png',

      rNormal:'../assets/right_normal.png',
      rHover:'../assets/right_hover.png',
      rPress:'../assets/right_press.png',

      showleftNomal:true,
      showleftHover:false,
      showleftPress:false,

      showrightNomal:true,
      showrightHover:false,
      showrightPress:false,
      active:-1,
      school_type:'',
      stateDialogShow: false,  //

      showCompanyleftNomal:true,
      showCompanyleftHover:false,
      showCompanyleftPress:false,

      showCompanyrightNomal:true,
      showCompanyrightHover:false,
      showCompanyrightPress:false,


      showCollegeleftNomal:true,
      showCollegeleftHover:false,
      showCollegeleftPress:false,

      // showCollegerightNomal
      showCollegerightNomal:true,
      showCollegerightHover:false,
      showCollegerightPress:false,

      // showTwoLeftNomal
      showTwoLeftNomal:true,
      showTwoLeftHover:false,
      showTwoLeftPress:false,

      // showTwoRightNomal
      showTwoRightNomal:true,
      showTwoRightHover:false,
      showTwoRightPress:false,

      // showFourLeftNomal
      showFourLeftNomal:true,
      showFourLeftHover:false,
      showFourLeftPress:false,
      // showFourRightNomal
      showFourRightNomal:true,
      showFourRightHover:false,
      showFourRightPress:false,
      isChinaTaiWan:false,
      isColorFlag: false
    }
  },
  components: {
    aboutJobfair,
    switchLoginStatus,
    NewIndex
  },
  computed: {
    // 公共参数domain：当前站点域名
    domain() {
      let domain = ''
      if(process.env.NODE_ENV == "development") {
          console.log('development')
          domain = window.location.origin.split('//')[1]
          //开发环境
      } else if (process.env.NODE_ENV == "production") {
          //生产环境
          console.log('production')
          domain = ''
      }
      return domain
    }
  },
  created() {
    // 获取站点下属院系配置
    this.getsitecollege()
    // 获取站点下属专业
    this.getsitemajors()
    this.initSchoolData()
    this.gethomeConfigMethod()

    this.getsiteInfo()
  },
  mounted() {
    document.addEventListener('scroll', this.scrollFunction,true)
    eventBus.$on('openLoginDialog1', val => {
      this.stateDialogShow = false
      this.loginDialogShow = val
      this.isJump = '2'
    })
    this.swipwer()
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.scrollFunction,true)
  },
  methods: {
    // 获取站点下属院系
    async getsitecollege() {
      const res = await getsitecollege({domain: this.domain})
      if(res) {
        this.collegeDept = res.college
      }
    },
    // 获取站点下属专业、
    async getsitemajors() {
      const res = await getsitemajors({domain: this.domain})
      if(res) {
        this.majors = res.majors
      }
    },
    async getsiteInfo() {
      const res = await getsiteInfo({domain: this.domain})
      this.siteType = res.type
      this.configData = res.school
      this.channelData = res.channel
      this.isChinaTaiWan = res.is_taiban == 1 ? true : false
      // 渠道
      if(this.siteType == 3 ) {
        this.setChannelMeta()
      }else if(this.siteType == 2) {
        if(this.configData.school_type == 1) {
          // 学校
          this.setSchoolMeta()
        }else {
          // 院系
          this.setCollegeMeta()
        }
      }
    },
      // 渠道
    setChannelMeta() {
      let metaMap = {}
      if(this.channelData.show_content == 3) {
        //  已开通学生端页面
        metaMap = {
          title: `${this.channelData.channel}校园招聘平台`,
          keyWord: `${this.channelData.channel},${this.channelData.short_name},校招平台,校园招聘会,校招`,
          desc: `${this.channelData.channel}校园招聘平台，学生求职，企业招聘。`
        }
      }else {
        // 未开通学生端页面 登录页
        metaMap = {
          title: `${this.channelData.channel}校园招聘平台用人单位登录`,
          keyWord: `${this.channelData.channel},${this.channelData.short_name},校招平台,校园招聘会,校招`,
          desc: `${this.channelData.channel}校园招聘平台，用人单位招聘入口。`
        }
      }
      setMeta(...Object.values(metaMap))
      console.log(metaMap);
      console.log(this.siteType, this.channelData)
    },
    // 学校
    setSchoolMeta() {
      console.log(this.configData, 'school');
      // 学校名称
      const schoolName = this.configData.school

      const metaMap = {
        title: `${schoolName}校园招聘平台，本校学生一键求职，专属职位推荐`,
        keyWord: `${schoolName}校园招聘平台,${schoolName},校招平台,校园招聘会,校招,求职,招聘`,
        desc: `${schoolName}校园招聘平台。本校学生一键求职，专属职位推荐。用人单位登录注册。${this.collegeDept}`
      }
      setMeta(...Object.values(metaMap))
    },
    // 院系
    setCollegeMeta() {
      const { school, college } = this.configData
      // 下属专业
      const majors = this.majors
      const metaMap = {
          title: `${school}${college}校园招聘平台，本院学生一键求职，专属职位推荐`,
          keyWord: `${school}${college}校园招聘平台,${school},${college},校招平台,校园招聘会,校招,求职,招聘`,
          desc: `${school}${college}校园招聘平台。本院学生一键求职，专属职位推荐。用人单位登录注册。${majors}`
      }
      setMeta(...Object.values(metaMap))
    },
    scrollFunction() {
      let offsetTop = window.pageYOffset ||document.documentElement.scrollTop ||document.body.scrollTop;
      //offsetTop是滚动条到顶部的距离
      if (offsetTop > 0) {
        this.$store.commit('header/setHeaderFixed', true);
      } else {
        this.$store.commit('header/setHeaderFixed', false);
      }

    },
    async initSchoolData() {
      try {
        let url = window.location.origin.split('//')[1]
        const res = await getSchoolData({domain: url})
        if(res.apiStatus) {
          // this.schoolName = res.school
          // this.schoolIcon = res.config.school_badge
          this.school_type = res.school_type
          console.log('index----')
          sessionStorage.setItem('school_type',JSON.stringify(this.school_type))
          // sessionStorage.setItem('schoolIcon',JSON.stringify(this.schoolIcon))
          if(this.school_type == 2){
            this.$router.push({ path: '/collegePosition' })
          }
        }
      }catch (e) {
        this.$Message.error('请求失败')
      }
    },
    //获取图片颜色平均值
    getcolor(){
      let that = this
      var canvas = document.createElement('canvas');
          //设置canvas的大小，动态获取也是可以的。
          canvas.width = 600;
          canvas.height = 350;
          //表示绘制一个2d图
          var context = canvas.getContext("2d");
          //获取图片元素
          var img = document.getElementById('myimg');
          //创建图片元素用来加载图片地址
          var nimg = new Image();
          nimg.crossOrigin = '';
          var isLoaded = img.complete && img.naturalHeight !== 0;

          if (isLoaded) {
          } else {
            nimg.onload = function () {
              var r = 0;
              var g = 0;
              var b = 0;
              var a = 0;
              var fxs = 600 * 300;
              //设置要绘制的图片
              context.drawImage(nimg, 0, 0);
              //获取图片的像素信息，并.data获得数组
              var data = context.getImageData(0, 0, 600, 300).data;
              //获取所有的rgba的和
              for (var i = 0; i < data.length / 4; i++) {
                  r += data[i * 4];
                  g += data[i * 4 + 1];
                  b += data[i * 4 + 2];
                  a += data[i * 4 + 3];
              }
              //获得平均值
              var rgb = 'rgb(' + parseInt(r / fxs) + ',' + parseInt(g / fxs) + ',' + parseInt(b / fxs) + ')';
              that.isColorFlag = (parseInt(r / fxs) + parseInt(g / fxs) + parseInt(b / fxs)) / 3 > 190 ? false : true
              console.log('=======isColorFlag==============',that.isColorFlag)
              if(that.isColorFlag){
                // 计算值
                that.color = rgb
              }else {
                //  固定值
                that.color = rgb
              }
              // that.isGetcolor = true
              if (parseInt(r / fxs) > 60 || parseInt(g / fxs) > 60 || parseInt(b / fxs) > 60) {
                console.log("成功")
                // that.hahaha(rgb)
              } else {
                console.log("失败")
              }
            }
            //将图片地址传给nimg
            setTimeout(()=>{
              nimg.src = that.head_img_url;
              console.log(nimg.src);
            })
          }

    },
    async gethomeConfigMethod() {
      try {
        let url = window.location.origin.split('//')[1]
        const res = await gethomeConfig({domain: url})
        // 头图
        this.head_img_url = res.domainData.head_img_url;
        if(this.head_img_url){
          this.getcolor()
        }
        // 配置数据
        this.datalist = res.dataList;

        //学院专区   companyArea 将数组加工成一个二维数组
        const schoolArr = res.school_college_zone
        const schLen = schoolArr.length  //len为数组的长度
        const nSchool = 12 // 假设每行显示4个
        const schNum = schLen % 12 === 0 ? schLen / 12 : Math.floor((schLen / 12) + 1)  //得出多少份
        for (let e = 0; e < schNum; e++) {
          // slice() 方法返回一个从开始到结束（不包括结束）的数组。且原始数组不会被修改。
          const schoolnewArr = schoolArr.slice(e * nSchool, e * nSchool + nSchool) //得到每份的数据
          this.schoolZone.push(schoolnewArr) //往res数组里加数据
        }

        //运营二区   companyArea 将数组加工成一个二维数组
        this.companyArea = res.companyArea
        const len = this.companyArea.length  //len为数组的长度
        const n = 12 // 假设每行显示4个
        const Num = len % 12 === 0 ? len / 12 : Math.floor((len / 12) + 1)  //得出多少份
        for (let i = 0; i < Num; i++) {
          // slice() 方法返回一个从开始到结束（不包括结束）的数组。且原始数组不会被修改。
          const newArr = this.companyArea.slice(i * n, i * n + n) //得到每份的数据
          this.newcompanyArea.push(newArr) //往res数组里加数据
        }


        // 运营一区
        const resbigFour = res.big_four
        const bigfourLen = resbigFour.length  //len为数组的长度
        const row = 11 //假设每行显示4个
        const bigfourNum = bigfourLen % 11 === 0 ? bigfourLen / 11 : Math.floor((bigfourLen / 11) + 1)  //得出多少份
        for (let m = 0; m < bigfourNum; m++) {
          const bigfournewArr = resbigFour.slice(m * row, m * row + row) //得到每份的数据
          this.zoneOne.push(bigfournewArr)
        }
        // 查看全部
        this.show_all = res.show_all

        //企业配置
        // JSON.parse(res.data.data.recruitHot)

        const companyArr = res.companyList
        const companyArrLen = companyArr.length  //len为数组的长度
        const companyRow = 8 //假设每行显示4个
        const companyNum = companyArrLen % 8 === 0 ? companyArrLen / 8 : Math.floor((companyArrLen / 8) + 1)  //得出多少份
        for (let n = 0; n < companyNum; n++) {
          const companynewArr = companyArr.slice(n * companyRow, n * companyRow + companyRow) //得到每份的数据
          this.companyConfingArr.push(companynewArr)
        }

        //职位配置
        // positionConfingArr
        const positionArr = JSON.parse(res.recruitHot)
        this.positionConfingArr = positionArr
        if(this.positionConfingArr.length > 20){
          this.length = 1
          this.newposConfingArr = positionArr
          this.positionConfingArr = this.positionConfingArr.slice(0, 20)
        }else{
          this.length = 0
          // this.positionConfingArr = positionArr
        }

        // 横幅招聘会
        const swiperArr = res.school_job_fair_zone
        // this.swiperList = res.school_job_fair_zone

        const swiperArrLen = swiperArr.length  //len为数组的长度
        const swiperRow = 3 //假设每行显示4个
        const swiperNum = swiperArrLen % 3 === 0 ? swiperArrLen / 3 : Math.floor((swiperArrLen / 3) + 1)  //得出多少份
        for (let s = 0; s < swiperNum; s++) {
          const swipernewArr = swiperArr.slice(s * swiperRow, s * swiperRow + swiperRow) //得到每份的数据
          this.swiperList.push(swipernewArr)
        }


        // 运营三区
        this.zoneThree = res.zoneThree
        if (this.zoneThree.length > 4) {
          this.zoneThree = this.zoneThree.slice(0, 4);
        }


        //  运营四区   companyArea 将数组加工成一个二维数组
        const fourArr = res.zoneFour
        const fourLen = fourArr.length  //len为数组的长度
        const nFour = 12 // 假设每行显示4个
        const NumFour = fourLen % 12 === 0 ? fourLen / 12 : Math.floor((fourLen / 12) + 1)  //得出多少份
        for (let j = 0; j < NumFour; j++) {
          // slice() 方法返回一个从开始到结束（不包括结束）的数组。且原始数组不会被修改。
          const newfourArr = fourArr.slice(j * nFour, j * nFour + nFour) //得到每份的数据
          this.zoneFour.push(newfourArr) //往res数组里加数据
        }


        // 关于本场招聘会
        this.jobfairIcon = JSON.parse(res.aboutus)



        // 区域展示配置顺序
        this.exhibition = JSON.parse(res.exhibition);
        this.exhibition.forEach((item) => {
          if (item.label == "数据配置") {
            this.data0 = item;
          } else if (item.label == "院系专区") {
            this.school0 = item;
          } else if (item.label == "运营一区") {
            this.open1 = item;
          } else if (item.label == "企业配置") {
            this.company0 = item;
          } else if (item.label == "招聘会") {
            this.jobfair0 = item;
          } else if (item.label == "职位配置") {
            this.position0 = item;
          } else if (item.label == "运营二区") {
            this.open2 = item;
          } else if (item.label == "运营三区") {
            this.open3 = item;
          } else if (item.label == "运营四区") {
            this.open4 = item;
          } else if (item.label == "关于本场招聘会") {
            this.about0 = item;
            this.aboutTitle = item.title;
          }
        });

        //再来一个数组，用于可排序
        this.sortList = JSON.parse(res.exhibition);

        this.sortList.splice(this.getIndex(this.sortList, "关于本场招聘会"), 1);

        this.sortList.splice(this.getIndex(this.sortList, "数据配置"), 1);

        this.sortList.splice(this.getIndex(this.sortList, "课程"), 1);

      }catch (e) {
        // this.$Message.error('接口请求失败')
      }
    },
      //写个方法，拿一下要去掉的的索引
    getIndex(arr, str) {
      let index = 0;
      index = arr.map(function (d) {return d["label"];}).indexOf(str);
      return index;
    },
    addIndex(){
      if(this.arrIndex < this.newcompanyArea.length){
        this.arrIndex += 1;
      }
    },
    delIndex(){
      if(this.arrIndex >= 1){
        this.arrIndex -= 1;
      }
    },
    addschIndex(){
      if(this.schIndex < this.schoolZone.length){
        this.schIndex += 1;
      }
    },
    delschIndex(){
      if(this.schIndex >= 1){
        this.schIndex -= 1;
      }
    },
    //运营一区按钮
    prevIndex(){
      if(this.bigfourIndex >= 1){
        this.bigfourIndex -= 1;
      }
    },
    nextIndex(){
      if(this.bigfourIndex < this.zoneOne.length){
        this.bigfourIndex += 1;
      }
    },
    comAdd(){
      if(this.comIndex < this.companyConfingArr.length){
        this.comIndex += 1;
      }
    },
    comDel(){
      if(this.comIndex >= 1){
        this.comIndex -= 1;
      }
    },
    addfourIndex(){
      if(this.fourIndex < this.zoneFour.length){
        this.fourIndex += 1;
      }
    },
    delfourIndex(){
      if(this.fourIndex >= 1){
        this.fourIndex -= 1;
      }
    },
    allPosition(){
      this.allposition = true
    },
    closePosition(){
      this.allposition = false
    },
    // swiper
    swipwer(){
      var mySwiper = new Swiper ('.swiper', {
        autoplay:true,
        slidesPerView :2,    //一个slides容器内展示的slides数量 可以为小数点
        spaceBetween : 16,      //在slides之间设置间距
        loop:true,
        observer:true,

        // 如果需要分页器
        pagination: {
          el: '.swiper-pagination',
        },

        // 如果需要前进后退按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      })
    },
    handleAbout(){
      this.listModal = true
    },
      //关闭弹框
      handleCloseClicks() {
        this.listModal = false
    },
    //关闭弹框
    handleCloseClick(val) {
      switch (val) {
        case '4':
          this.loginDialogShow = false
          eventBus.$emit('setLoginState')  // 向newHeader组件进行传值
              break
        case '5':
          this.stateDialogShow = false
              break
      }
      initSlide()
    },
    //
    mouseenter(){
      this.showrightNomal=false
      this.showrightHover= true
      this.showrightPress = false
    },
    mouseout(){
      this.showrightHover= false
      this.showrightNomal = true
      this.showrightPress = false

    },
    mousedown(){
      this.showrightHover= false
      this.showrightNomal = false
      this.showrightPress = true
    },
    mouseup(){
      this.showrightPress = false
      this.showrightHover= false
      this.showrightNomal = true

    },
    mouseenterOneLeft(){
      this.showleftNomal=false
      this.showleftHover= true
      this.showleftPress = false
    },
    mouseoutOneLeft(){
      this.showleftHover= false
      this.showleftNomal = true
      this.showleftPress = false
    },
    mousedownOneLeft(){
      this.showleftHover= false
      this.showleftNomal = false
      this.showleftPress = true

    },
    mouseupOneLeft(){
      this.showleftPress = false
      this.showleftHover= false
      this.showleftNomal = true
    },
    // mouseenterCompanyLeft
    mouseenterCompanyLeft(){
      this.showCompanyleftNomal=false
      this.showCompanyleftHover= true
      this.showCompanyleftPress = false
    },
    mouseoutCompanyLeft(){
      this.showCompanyleftHover= false
      this.showCompanyleftNomal = true
      this.showCompanyleftPress = false
    },
    mousedownCompanyLeft(){
      this.showCompanyleftHover= false
      this.showCompanyleftNomal = false
      this.showCompanyleftPress = true

    },
    mouseupCompanyLeft(){
      this.showCompanyleftPress = false
      this.showCompanyleftHover= false
      this.showCompanyleftNomal = true
    },


    mouseenterCompanyRight(){
      this.showCompanyrightNomal=false
      this.showCompanyrightHover= true
      this.showCompanyrightPress = false
    },
    mouseoutCompanyRight(){
      this.showCompanyrightHover= false
      this.showCompanyrightNomal = true
      this.showCompanyrightPress = false
    },
    mousedownCompanyRight(){
      this.showCompanyrightHover= false
      this.showCompanyrightNomal = false
      this.showCompanyrightPress = true

    },
    mouseupCompanyRight(){
      this.showCompanyrightPress = false
      this.showCompanyrightHover= false
      this.showCompanyrightNomal = true
    },

    mouseenterCollegeLeft(){
      this.showCollegeleftNomal=false
      this.showCollegeleftHover= true
      this.showCollegeleftPress = false
    },
    mouseoutCollegeLeft(){
      this.showCollegeleftHover= false
      this.showCollegeleftNomal = true
      this.showCollegeleftPress = false
    },
    mousedownCollegeLeft(){
      this.showCollegeleftHover= false
      this.showCollegeleftNomal = false
      this.showCollegeleftPress = true

    },
    mouseupCollegeLeft(){
      this.showCollegeleftPress = false
      this.showCollegeleftHover= false
      this.showCollegeleftNomal = true
    },

    mouseenterCollegeRight(){
      this.showCollegerightNomal=false
      this.showCollegerightHover= true
      this.showCollegerightPress = false

    },
    mouseoutCollegeRight(){
      this.showCollegerightHover= false
      this.showCollegerightNomal = true
      this.showCollegerightPress = false
    },
    mousedownCollegeRight(){
      this.showCollegerightHover= false
      this.showCollegerightNomal = false
      this.showCollegerightPress = true

    },
    mouseupCollegeRight(){
      this.showCollegerightPress = false
      this.showCollegerightHover= false
      this.showCollegerightNomal = true
    },

    mouseenterTwoLeft(){
      this.showTwoLeftNomal=false
      this.showTwoLeftHover= true
      this.showTwoLeftPress = false
    },
    mouseoutTwoLeft(){
      this.showTwoLeftHover= false
      this.showTwoLeftNomal = true
      this.showTwoLeftPress = false
    },
    mousedownTwoLeft(){
      this.showTwoLeftHover= false
      this.showTwoLeftNomal = false
      this.showTwoLeftPress = true

    },
    mouseupTwoLeft(){
      this.showTwoLeftPress = false
      this.showTwoLeftHover= false
      this.showTwoLeftNomal = true
    },
    mouseenterTwoRight(){
      this.showTwoRightNomal=false
      this.showTwoRightHover= true
      this.showTwoRightPress = false

    },
    mouseoutTwoRight(){
      this.showTwoRightHover= false
      this.showTwoRightNomal = true
      this.showTwoRightPress = false
    },
    mousedownTwoRight(){
      this.showTwoRightHover= false
      this.showTwoRightNomal = false
      this.showTwoRightPress = true

    },
    mouseupTwoRight(){
      this.showTwoRightPress = false
      this.showTwoRightHover= false
      this.showTwoRightNomal = true
    },
    // mouseenterFourLeft
    mouseenterFourLeft(){
      this.showFourLeftNomal=false
      this.showFourLeftHover= true
      this.showFourLeftPress = false
    },
    mouseoutFourLeft(){
      this.showFourLeftHover= false
      this.showFourLeftNomal = true
      this.showFourLeftPress = false
    },
    mousedownFourLeft(){
      this.showFourLeftHover= false
      this.showFourLeftNomal = false
      this.showFourLeftPress = true

    },
    mouseupFourLeft(){
      this.showFourLeftPress = false
      this.showFourLeftHover= false
      this.showFourLeftNomal = true
    },

    mouseenterFourRight(){
      this.showFourRightNomal=false
      this.showFourRightHover= true
      this.showFourRightPress = false

    },
    mouseoutFourRight(){
      this.showFourRightHover= false
      this.showFourRightNomal = true
      this.showFourRightPress = false
    },
    mousedownFourRight(){
      this.showFourRightHover= false
      this.showFourRightNomal = false
      this.showFourRightPress = true

    },
    mouseupFourRight(){
      this.showFourRightPress = false
      this.showFourRightHover= false
      this.showFourRightNomal = true
    },

    enterAll(){
      this.active = 0
    },
    mouseupAll(){
      this.active = -1

    },
    mousedownPositionAll(){
      this.active = 0

    },
    mouseupPositionAll(){
      this.active = -1
    },

    //职位列表点击
    handlPosition(value, label, period) {
        const { href } = this.$router.resolve({
          path: '/positionList',
          query: {
            value: value,
            label:label,
            period:period
          }
        })
        window.open(href, '_blank')
    },
    //企业配置--查看全部
    handleClickcompanyAll(){
      const { href } = this.$router.resolve({
          path: '/companyList',
          query: {
            // id: row.id
            isAll:1,
          }
        })
        window.open(href, '_blank')
    },
    handleJobfair(row){
      const { href } = this.$router.resolve({
          path: '/jobFair',
          query: {
            id: row.id
          }
        })
        window.open(href, '_blank')
    },
    // 运营一区点击跳转
    zoneOneClick(id,config_type,config_content,item){
      console.log(item);
      // return
      if(config_type == 1){
        const { href } = this.$router.resolve({
          path: '/positionList',
          query: {
            zoneid: id,
            title: item.title
            // config_type:config_type,
            // config_content:config_content
          }
        })
        window.open(href, '_blank')
      }else if(config_type == 2 || config_type == 3){
        const { href } = this.$router.resolve({
          path: '/companyList',
          query: {
            zoneid: id,
            title: item.title
            // config_type:config_type,
            // config_content:config_content,

          }
        })
        window.open(href, '_blank')
      }else if(config_type == 4){
        // 文章
        const { href } = this.$router.resolve({
          path: '/wenList',
          query: {
            id:id,
            title: item.title
          }
        })
        window.open(href, '_blank')

      }else if(config_type == 5){
        // 内容素材
        const { href } = this.$router.resolve({
          path: '/contentListNew',
          query: {
            id:id,
            title: item.title
          }
        })
        window.open(href, '_blank')

      }else if(config_type == 6){
        //
        // 站点跳转
        if(item.config_content_details){
            let domain = item.config_content_details.web_domain
            let href = '//'+domain+'#/'
            window.open(href, '_blank')
        }
      }
    },
    zoneTwoClick(id,config_type,config_content,item){
      console.log(item, config_type);
      // return
      if(config_type == 1){
        const { href } = this.$router.resolve({
          path: '/positionList',
          query: {
            zoneid: id,
            title: item.title
            // config_type:config_type,
            // config_content:config_content
          }
        })
        window.open(href, '_blank')
      }else if(config_type == 2 || config_type == 3){
        const { href } = this.$router.resolve({
          path: '/companyList',
          query: {
            zoneid: id,
            title: item.title
            // config_type:config_type,
            // config_content:config_content
          }
        })
        window.open(href, '_blank')
      }else if(config_type == 4){
        // 文章
        const { href } = this.$router.resolve({
          path: '/wenList',
          query: {
            id:id,
            title: item.title
          }
        })
        window.open(href, '_blank')

      }else if(config_type == 5){
        // 内容素材
        const { href } = this.$router.resolve({
          path: '/contentListNew',
          query: {
            id:id,
            title: item.title
          }
        })
        window.open(href, '_blank')

      }else if(config_type == 6){
        //
        // 站点跳转
        if(item.config_content_details){
            let domain = item.config_content_details.web_domain
            let href = '//'+domain+'#/'
            window.open(href, '_blank')
        }

      }
    },
    handleZonethree(id,config_type,config_content,item){
      if(config_type == 1){
        const { href } = this.$router.resolve({
          path: '/positionList',
          query: {
            zoneid: id,
            title: item.title
            // config_type:config_type,
            // config_content:config_content
          }
        })
        window.open(href, '_blank')
      }else if(config_type == 2 || config_type == 3){
        const { href } = this.$router.resolve({
          path: '/companyList',
          query: {
            zoneid: id,
            title: item.title
            // config_type:config_type,
            // config_content:config_content
          }
        })
        window.open(href, '_blank')
      }else if(config_type == 4){
        // 文章
        const { href } = this.$router.resolve({
          path: '/wenList',
          query: {
            id:id,
            title: item.title
          }
        })
        window.open(href, '_blank')

      }else if(config_type == 5){
        // 内容素材
        const { href } = this.$router.resolve({
          path: '/contentListNew',
          query: {
            id:id,
            title: item.title
          }
        })
        window.open(href, '_blank')

      }else if(config_type == 6){
        //
          // 站点跳转
          if(item.config_content_details){
            let domain = item.config_content_details.web_domain
            let href = '//'+domain+'#/'
            window.open(href, '_blank')
        }
      }
    },
    handleZoneFour(id,config_type,config_content,item){
      console.log(item.config_type);
      // return
      if(config_type == 1){
        const { href } = this.$router.resolve({
          path: '/positionList',
          query: {
            zoneid: id,
            title: item.title
            // config_type:config_type,
            // config_content:config_content
          }
        })
        window.open(href, '_blank')
      }else if(config_type == 2 || config_type == 3){
        const { href } = this.$router.resolve({
          path: '/companyList',
          query: {
            zoneid: id,
            title: item.title
            // config_type:config_type,
            // config_content:config_content
          }
        })
        window.open(href, '_blank')
      }else if(config_type == 4){
        // 文章
        const { href } = this.$router.resolve({
          path: '/wenList',
          query: {
            id:id,
            title: item.title
          }
        })
        window.open(href, '_blank')

      }else if(config_type == 5){
        // 内容素材
        const { href } = this.$router.resolve({
          path: '/contentListNew',
          query: {
            id:id,
            title: item.title
          }
        })
        window.open(href, '_blank')

      }else if(config_type == 6){
        // 站点跳转
        if(item.config_content_details){

          let domain = item.config_content_details.web_domain
          let href = '//'+domain+'#/'
          window.open(href, '_blank')
        }

      }
    },
    //企业配置
    handleCompanyconfing(id){
      const { href } = this.$router.resolve({
          path: '/companyDetailPage',
          query: {
            id: id,
          }
        })
        window.open(href, '_blank')
    },
    handleCollege(item){
      // this.$router.push('/')
      // this.setShowcolleageHead
      // this.$store.commit('header/setShowcolleageHead', true);
      // const href = 'https://'+item.domain+'#/collegePosition'
      // const href = 'http://baidu.com'
      // transferPage
      let userid  = Cookies.get('user_id')
      let com_key_user = Cookies.get('com_key_user')
      let login_type =  Cookies.get('login_type')
      let href = ''
      if(Cookies.get('login_type') == 'company'){
        href = '//' + item.domain+'#/transferPage'+'?com_key_user='+com_key_user+'&login_type='+login_type

      }else{
        href = '//' + item.domain+'#/transferPage'+'?user_id='+userid+'&login_type='+login_type

      }
      // let logo = encodeURIComponent(item.thumbnail_url)
      // console.log('logo',logo,item.thumbnail_url)
      // let del = decodeURIComponent(logo)
      // console.log('del',del,item.thumbnail_url)
      // let href = '//' + item.domain+'#/transferPage'+'?user_id='+userid+'&login_type='+login_type

      // const { href } = this.$router.resolve({
      //     path: '/transferPage',
      //     query: {
      //       id: Cookies.get('user_id'),
      //       herf: item.domain
      //     }
      //   })

        window.open(href, '_blank')

    }

  }
}
</script>

<style scoped lang="less">
@import 'swiper/swiper-bundle.min.css';
  .changeStyle{
    cursor:pointer;
  }
  .contentBox {
    background-color: #FFFFFF;
    width: 100%;
    padding-bottom: 96px;
    .contentMain {
      padding-top: 12px;
      .jobfairTop{
        margin: 0 auto;
        overflow: hidden;
        width: 1200px;
        height: 210px;
        display: flex;
        border-radius:8px ;
        .jobfairImg{
          width: 584px;
          height: 210px;
          border-top-left-radius:8px;
          border-bottom-left-radius:8px;
        }
        .jobInfoContent{
          width: 616px;
          height: 210px;
          // background: red;
          padding-top: 42px;
          padding-left: 136px;
          padding-right: 136px;

        }
        .jobfairInfo{
          display: flex;
          margin-right: 64px;
          height: 52px;
          .imageStyle{
            width: 34px;
            height: 34px;
            margin-top: 12px;
            margin-right: 12px;
            // border: 1px solid #EEEEEE;
            // border-radius: 4px;
            img{
              display: block;
              margin: 0;
              padding: 0;
            }
          }
          .textInfo{
            .number{
              width: 96px;
              height: 30px;
              line-height: 30px;
              font-size: 24px;
              font-weight: bold;
              color: #FFFFFF;
              margin-bottom: 4px;
            }
            .textdesc{
              width: 96px;
              font-size: 14px;
              color: rgba(255,255,255,0.9);
            }
          }


        }
        .jobfairInfo:nth-child(2){
          margin-right: 0;
        }
        .jobfairInfo:nth-child(4){
          margin-right: 0;
        }
        .jobInfoContentCopy {
          width: 616px;
          height: 210px;
          background: url("../assets/homeImg/img_bg.png") center no-repeat;
          background-size: 100% 100%;
          padding-top: 42px;
          padding-left: 136px;
          padding-right: 136px;

          .jobfairInfo{
            display: flex;
            margin-right: 64px;
            height: 52px;
            .imageStyle{
              width: 34px;
              height: 34px;
              margin-top: 12px;
              margin-right: 12px;
              // border: 1px solid #EEEEEE;
              // border-radius: 4px;
              img{
                display: block;
                margin: 0;
                padding: 0;
              }
            }
            .textInfo{
              .number{
                width: 96px;
                height: 30px;
                line-height: 30px;
                font-size: 24px;
                font-weight: bold;
                color: #345581;
                margin-bottom: 4px;
              }
              .textdesc{
                width: 96px;
                font-size: 14px;
                color: #395376;
              }
            }


          }
          .jobfairInfo:nth-child(2){
            margin-right: 0;
          }
          .jobfairInfo:nth-child(4){
            margin-right: 0;
          }
        }
      }

      // 学院相关
      .college-content{
        width: 1264px;
        margin: 0 auto;
        overflow: hidden;
        margin-top: 40px;
        .college-title{
          padding-left: 32px;
          font-size: 22px;
          font-weight: bold;
          color: #17233D;
          margin-bottom: 20px;
        }
        .college-item{
          display: flex;
          .flip-left{
            width: 32px;
            height: 94px;
            padding-right: 8px;
            position: relative;
            img{
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
            }
          }
          .college-img{
            width: 1194px;
            height: 94px;
            display: flex;
            // overflow: hidden;
            .imgBox{
              width: 85px;
              height: 85px;
              border-radius: 6px;
              overflow: hidden;
              margin-right: 16px;
            }
            .imgBox :hover{
              //  box-shadow: 0px 2px 4px 0px rgba(204, 204, 204, 0.5);
            }
            img{
              margin-right: 16px;
              border-radius: 6px;

            }
            img :nth-child(2n){
              margin-right: 0px;
            }
            img:hover{
                transition: 0.2s;
                transform: scale(1.1);
            }
          }

          .flip-right{
            width: 32px;
            height: 94px;
            padding-left: 8px;
            position: relative;
            img{
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }

      }
      //  热门职位
      .host-position{
        // width: 1264px;
        width: 1268px;
        margin: 0 auto;
        overflow: hidden;
        margin-top: 40px;
        .host-title {
          padding-left: 32px;
          font-size: 22px;
          font-weight: bold;
          color: #17233D;
          margin-bottom: 20px;
        }
        .host-content{
          display: flex;
          .flip-left{
            width: 32px;
            height: 94px;
            padding-right: 8px;
            position: relative;
            img{
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
            }
          }
          .host-img{
            width: 1196px;
            height: 96px;
            display: flex;
            overflow: hidden;
            .host-Box{
              width: 94px;
              height: 96px;
              background: #F8F8F8;
              border-radius: 6px;
              margin-right: 16px;
              // overflow: hidden;
              .host-item-img{
                width: 56px;
                height: 56px;
                margin-top: 8px;
                margin-left: 19px;
                margin-right: 19px;
                overflow: hidden;
                border-radius: 6px;
                img{
                  margin-right: 16px;
                }
              }
              .host-name{
                font-size: 14px;
                font-weight: 400;
                color: #333333;
                margin-top: 4px;
                text-align: center;
              }
            }
            .host-Box:hover{
              // box-shadow: 0px 2px 4px 0px #CCCCCC;
              img{
                transition: 0.2s;
                transform: scale(1.1);
              }
            }
            // img :nth-child(11){
            //   margin-right: 0px;
            // }
          }

          .flip-right{
            width: 32px;
            height: 94px;
            padding-left: 8px;
            position: relative;
            img{
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }
      }

      //企业配置
      .enterprise-confing{
        width: 1264px;
        margin: 0 auto;
        overflow: hidden;
        margin-top: 40px;
        .enterprise-top {
          padding-left: 32px;
          margin-bottom: 4px;
          display: flex;
          justify-content: space-between;
          .enterprise-title{
            font-size: 22px;
            font-weight: bold;
            color: #17233D;
          }
          .view-more{
            font-size: 14px;
            font-weight: 400;
            line-height: 36px;
            color: #515A6E;
          }

          .view-morePress{
            font-size: 14px;
            font-weight: 400;
            line-height: 36px;
            color: #2F63E0;
          }
          .view-more:hover{
            color: #356FFA;
            i{
                color: #356FFA;
            }
          }
        }
        .host-content{
          display: flex;
          .flip-left{
            width: 32px;
            height: 176px;
            padding-right: 8px;
            position: relative;
            img{
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
            }
          }
          .enterprise-content{
            width: 1200px;
            // height: 94px;
            display: flex;
            flex-wrap:wrap;
            // width: calc(1200px - 288px);
            .content-model{
              width: 276px;
              margin-right: 28px;
            }
            .content-model:nth-child(4n){
              margin-right: 0;
            }
            .content-box{
              display: flex;
              width: 276px;
              // margin-left: 16px;
              margin-top: 16px;
              .content-left{
                width: 64px;
                height: 64px;
                border: 1px solid #eeeeee;
                border-radius: 4px;

                overflow: hidden;
                // img{
                // }
                margin-right: 12px;
              }
              .content-right{
                height: 66px;
                width: 200px;
                .companyName{
                  width: 200px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                  margin-top: 7px;
                  font-size: 16px;
                  color: #17233D;
                  margin-bottom: 12px;
                }
                .companyLabel{
                  font-size: 12px;
                  color: #808695;
                  width: 200px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
              }
            }
            .content-box:hover{
              img{
                transition: 0.2s;
                transform: scale(1.1);
              }
              .companyName{
                color: #356FFA;
              }

            }
            .content-box:nth-child(1){
              margin-left: 0px;
            }
            .content-box:nth-child(5){
              margin-left: 0px;
            }
          }

          .flip-right{
            width: 32px;
            height: 176px;
            padding-left: 8px;
            position: relative;
            img{
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }
      }


      //职位配置
      .position-confing{
        position: relative;
        width: 100%;
        margin-top: 32px;
        // margin: 0 auto;
        // height: 260px;
        // background: linear-gradient(180deg, #F7FAFF 0%, #FFFFFF 100%);
        background: linear-gradient(180deg, #ECF6FF 0%, #FFFFFF 100%);
        // background: red;

        .position-content{
          width: 1200px;
          margin: 0 auto;
          // position: relative;
          .position-title{
            padding-top: 32px;
            font-size: 22px;
            font-weight: bold;
            color: #17233D;
            padding-bottom: 32px;
          }
          .position-item{
            width: 105px;
            height: 44px;
            position: relative;
            // overflow: hidden;
            // background: pink;
            // background: #F7FAFF;
            background: #ECF2FF;
            border-radius: 4px;
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            text-align: center;
            line-height: 44px;
            margin-left: 16px;
            margin-bottom: 16px;
            .host{
              position: absolute;
              right: 0;
              top: -50%;
            }
          }
          .position-item:hover{
            background: #356FFA;
            color: #FFFFFF;
          }

          .position-item:nth-child(10n+1){
            margin-left: 0;
          }
          // .position-item:nth-child(11){
          //   margin-left: 0;
          // }

          .seeAll{
            margin: 0 auto;
            width: 112px;
            height: 36px;
            border-radius: 4px;
            border: 1px solid #EDEFF3;
            text-align: center;
            line-height: 36px;
          }
          .seeAllPress{
            margin: 0 auto;
            width: 112px;
            height: 36px;
            border-radius: 4px;
            // border: 1px solid #EDEFF3;
            border: 1px solid #116AD6;
            color: #116AD6;
            text-align: center;
            line-height: 36px;
          }
          .seeAll:hover{
            border: 1px solid #356FFA;
            color: #1477EF;
          }
        }
      }

      //横幅招聘会
       .swiper{
        width: 1200px;
        height: 146px;
        margin-top: 32px;
        .swiper-itemStyle{
          display: flex;
          // margin-right: 16px;
        }
        // .swiper-itemStyle:nth-child(3n){
        //   margin-right: 0;
        // }

        .swiper-box{
          width: 389px;
          height: 114px;
          margin-right: 16px;
          border-radius: 8px;
          overflow: hidden;
        }
        .swiper-box:nth-child(3n){
          margin-right: 0;
        }
        .swiper-box:hover{
          img{
            transition: 0.2s;
            transform: scale(1.1);
          }
        }
        // --swiper-theme-color: #ff6600;
        --swiper-pagination-color: #00ff33;/* 两种都可以 */
      }

      /deep/ .swiper{
        z-index: 0;
      }


      // 运营二区
      .zone-two{
        width: 1264px;
        margin: 0 auto;
        overflow: hidden;
        margin-top: 40px;
        .two-title{
          padding-left: 32px;
          font-size: 22px;
          font-weight: bold;
          color: #17233D;
          margin-bottom: 20px;
        }
        .two-item{
          display: flex;
          .flip-left{
            width: 32px;
            height: 85px;
            padding-right: 8px;
            position: relative;
            img{
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
            }
          }
          .two-img{
            width: 1194px;
            height: 94px;
            display: flex;
            // overflow: hidden;
            .two-imgBox{
              width: 85px;
              height: 85px;
              border-radius: 6px;
              overflow: hidden;
              margin-right: 16px;
            }
            img{
              margin-right: 16px;
              border-radius: 6px;

            }
            img :nth-child(11){
              margin-right: 0px;
            }
            .two-imgBox:hover{
              // box-shadow: 0px 2px 4px 0px rgba(204, 204, 204, 0.5);
              img{
                transition: 0.2s;
                transform: scale(1.1);
              }
            }
          }

          .flip-right{
            width: 32px;
            height: 85px;
            padding-left: 8px;
            position: relative;
            img{
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }

      }

      // 运营三区
      .zone-three{
        width: 1200px;
        margin: 0 auto;
        overflow: hidden;
        margin-top: 40px;
        .three-title{
          font-size: 22px;
          font-weight: bold;
          color: #17233D;
          margin-bottom: 20px;
          margin-right: 16px;
        }
        .three-box{
          display: flex;
          // width: 277px;
          height: 82px;
          // overflow: hidden;
          border-radius: 6px;
          .three-imgbox{
            width:196px;
            height: 82px;
            margin-right: 16px;
            border-radius: 6px;
            overflow: hidden;
          }
          .three-imgbox:hover{
            // box-shadow: 0px 2px 4px 0px rgba(204, 204, 204, 0.5);
            img{
              transition: 0.2s;
              transform: scale(1.1);
            }
          }

        }
      }

      // 运营四区
      .zone-four{
        width: 1264px;
        margin: 0 auto;
        overflow: hidden;
        margin-top: 40px;
        .four-title{
          padding-left: 32px;
          font-size: 22px;
          font-weight: bold;
          color: #17233D;
          margin-bottom: 20px;
        }
        .four-item{
          display: flex;
          .flip-left{
            width: 32px;
            height: 85px;
            padding-right: 8px;
            position: relative;
            img{
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
            }
          }
          .four-img{
            width: 1194px;
            height: 85px;
            display: flex;
            // overflow: hidden;
            .four-imgBox{
              width: 85px;
              height: 85px;
              border-radius: 6px;
              margin-right: 16px;
              overflow: hidden;
            }
            img{
              margin-right: 16px;
              border-radius: 6px;

            }
            img :nth-child(11){
              margin-right: 0px;
            }
            .four-imgBox:hover{
              // box-shadow: 0px 2px 4px 0px rgba(204, 204, 204, 0.5);
              img{
                transition: 0.2s;
                transform: scale(1.1);
              }
            }
          }

          .flip-right{
            width: 32px;
            height: 85px;
            padding-left: 8px;
            position: relative;
            img{
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }

      }


      // 关于本场招聘会
      .about{
        width: 1200px;
        margin: 0 auto;
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        // margin-bottom: 96px;
        .left-line{
          width: 92px;
          height: 1px;
          border: 1px solid #EDEFF3;
          margin-right: 8px;
        }
        .aboutCon{
          // margin: 0 auto;
          width: 156px;
          height: 40px;
          background: #F6F7F9;
          border-radius: 4px;
          text-align: center;
          line-height: 40px;

        }
        .aboutCon:hover{
          background: #356FFA;
          color: #FFFFFF
        }
        .right-line{
          width: 92px;
          height: 1px;
          border: 1px solid #EDEFF3;
          margin-left: 8px;
        }
      }
    }
  }
  /deep/.el-carousel__button{
    width: 8px;
    height: 8px;
    // background: red;
    background: #356FFA;
    border-radius: 50%;
  }
  /deep/.el-carousel__indicators--outside button{
    width: 8px;
    height: 8px;
    // background: red;
    background: #356FFA;
    border-radius: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/view/indexPage.vue